import React from 'react';
import qs from 'qs';

export const Linked = () => {
  const { id } = qs.parse(window.location.search, { ignoreQueryPrefix: true });
  return (
    <>
      Your Enface ID is linked with current account<br /><br /><strong>{id}</strong>
    </>
  );
};
